module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"placeHolder":"Enter a keyword to search for FAQ","categoryTitle":"CATEGORIES"},"es":{"placeHolder":"Introduzca una palabra clave para buscar preguntas frecuentes","categoryTitle":"Categorías"}}')
  delete Component.options._Ctor
}
